export const firebaseConfig = {
  apiKey: 'AIzaSyC1B6OwyBcbFX1vlF6pxPUunC_yoge4ujo',
  authDomain: 'notifications-realtime.firebaseapp.com',
  databaseURL: 'https://notifications-realtime.firebaseio.com',
  projectId: 'notifications-realtime',
  storageBucket: 'notifications-realtime.appspot.com',
  messagingSenderId: '120235207080',
};
